// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.msgContainer[data-v-697fd90c] .pEditor p {\n  margin: 0!important;\n}\n.detailStyle .el-form-item[data-v-697fd90c] {\n  margin-bottom: 10px;\n}\n.msgContainer[data-v-697fd90c] {\n  padding:20px;\n}\n", ""]);
// Exports
module.exports = exports;
